<div class="d-flex flex-column justify-content-center align-items-center w-100 px-5">

    <!-- NIF/NIE -->
    <div class="row w-100 mb-2">

        <div class="col-12">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder" [appAsterisk]="true">DNI/NIE</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.dni"/>
            </div>
        </div>

    </div>

    <!-- Nombre y apellidos -->
    <div class="row w-100 mb-2">

        <div class="col-12 col-lg-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder" [appAsterisk]="true">Nombre</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.name"/>
            </div>
        </div>

        <div class="col-12 col-lg-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder" [appAsterisk]="true">Apellidos</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.surname"/>
            </div>
        </div>

    </div>

    <!-- Correo electrónico -->
    <div class="row w-100 mb-2">

        <div class="col-12 col-lg-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder" [appAsterisk]="true">Correo electrónico</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.mail" (ngModelChange)="onEmailChange()"/>
                <small *ngIf="!isValidEmail" class="text-danger-color" >{{emailValidationError}}</small>
            </div>
        </div>

        <div class="col-12 col-lg-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder" [appAsterisk]="true">Confirmar correo electrónico</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutorEmailConfirmation" (ngModelChange)="onEmailConfirmationChange()"/>
                <small *ngIf="!isValidEmailConfirmation" class="text-danger-color" >{{emailConfirmationValidationError}}</small>
            </div>
        </div>

    </div>

    <!-- Contraseña -->
    <div class="row w-100 mb-2">

        <div class="col-12 col-lg-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder" [appAsterisk]="true">Contraseña</span>
                <input type="password" pInputText class="w-100" [(ngModel)]="tutor.password" (ngModelChange)="onPasswordChange()"/>
                <small *ngIf="!isValidPassword" class="text-danger-color" >{{passwordValidationError}}</small>
            </div>
        </div>

        <div class="col-12 col-lg-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder" [appAsterisk]="true">Confirmar contraseña</span>
                <input type="password" pInputText class="w-100" [(ngModel)]="tutorPasswordConfirmation" (ngModelChange)="onPasswordConfirmationChange()"/>
                <small *ngIf="!isValidPasswordConfirmation" class="text-danger-color" >{{passwordConfirmationValidationError}}</small>
            </div>
        </div>

    </div>

    <!-- Teléfonos -->
    <div class="row w-100 mb-2">

        <div class="col-12 col-lg-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder" [appAsterisk]="true">Teléfono 1</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.phone1"/>
            </div>
        </div>

         <div class="col-12 col-lg-6">
            <div class="d-flex flex-column justify-content-center align-items-start w-100">
                <span class="text-primary-color fw-bolder">Teléfono 2</span>
                <input type="text" pInputText class="w-100" [(ngModel)]="tutor.phone2"/>
            </div>
        </div>

    </div>

    <div class="row w-100 mb-2">

        <!-- Success alert -->
        <div *ngIf="showSuccessAlert" class="col-12">
            <div class="alert alert-success alert-dismissible fade show w-100 m-0" role="alert">
                <span>{{ successMessage }}</span>
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>

        <!-- Error alert -->
        <div *ngIf="showErrorAlert" class="col-12">
            <div class="alert alert-danger w-100 m-0" role="alert">
                {{ errorMessage }}
            </div>
        </div>

    </div>

    <div class="row w-100 mb-2 mt-4">

        <div class="col-12">

            <div class="d-flex flex-column justify-content-center align-items-start w-100">

                <button type="button" class="btn button-accent-color w-100 py-2"
                    [disabled]="!isFormValid() || isProcessing"
                    (click)="postTutor()">

                    <div *ngIf="!isProcessing" class="w-100">
                        <span class="fs-6">Crear usuario</span>
                    </div>

                    <div *ngIf="isProcessing" class="d-flex flex-row justify-content-center align-items-center w-100">
                        <fa-icon [icon]="['fas', 'spinner']" [spin]="true"></fa-icon>
                    </div>

                </button>

            </div>

        </div>

    </div>

</div>
